
















import { Component, Prop, Vue } from 'vue-property-decorator'

import { ModalState } from '@/models'

@Component
export default class ConfirmLeaveModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState
}
